import { createAction } from '@reduxjs/toolkit';
import type { RecordOf } from 'immutable';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayloadProps } from 'app-components/flux/core/resourceStoreTypes';

import type { InvestmentSymbolProps } from './investmentSymbolsTypes';

export type InvestmentSymbolsSuccessPayload = RecordOf<QcsSyncResourcesPayloadProps<InvestmentSymbolProps>>;

export const getInvestmentSymbols = createAction(
  'GET_INVESTMENT_SYMBOL_LOOKUP',
  getPayloadCreator<void, InvestmentSymbolProps>(),
);
export const getInvestmentSymbolsSuccess = createAction(
  'GET_INVESTMENT_SYMBOL_LOOKUP_SUCCESS',
  getPayloadCreator<InvestmentSymbolsSuccessPayload>(),
);
export const getInvestmentSymbolsFailure = createAction(
  'GET_INVESTMENT_SYMBOL_LOOKUP_FAILURE',
  getPayloadCreator<unknown>(),
);
